var map = {
	"./1.png": "OvMy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VGje";


//////////////////
// WEBPACK FOOTER
// ./apps/www.bravenet.com/src/assets/img/shared/promos/2024/blackfridaysale/1138x90 ^\.\/.*\.png$
// module id = VGje
// module chunks = 0